import { render, staticRenderFns } from "./PfandSetting.vue?vue&type=template&id=59f6bd4f&scoped=true&"
import script from "./PfandSetting.vue?vue&type=script&lang=js&"
export * from "./PfandSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f6bd4f",
  null
  
)

export default component.exports